'use client'

import { useState, useEffect } from 'react'
import { QuickSearchResponseRecord } from '@/search/types'
import TypesenseClient from '@/search/Typesense'

const client = new TypesenseClient()

interface UseProductRecommendationsProps {
  excludeObjectId: string
  categories?: string[]
  creators?: string
  searchTerm?: string
  limit?: number
}

export function useProductRecommendations({
  excludeObjectId,
  categories,
  creators,
  searchTerm,
  limit = 4,
}: UseProductRecommendationsProps) {
  const [results, setResults] = useState<QuickSearchResponseRecord[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!excludeObjectId) return

    let cancelled = false

    const fetch = async () => {
      setIsLoading(true)
      const response = await client.searchRecommendations({
        excludeObjectId,
        categories,
        creators,
        searchTerm,
        limit,
      })
      if (!cancelled) {
        setResults(response.hits)
        setIsLoading(false)
      }
    }

    fetch()

    return () => {
      cancelled = true
    }
  }, [excludeObjectId, categories, creators, searchTerm, limit])

  return { results, isLoading }
}
